import { Button, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';
import { useNotification } from '@/context/notification';
import { useDeletePlanActivity } from '@/data/idp/plans/activities';
import type { Activity } from '@/data/idp/plans/interfaces';
import { IdpEvent } from '@/constants/analytics';
import {
  buildIdpActivityProperties,
  useIdpPlan,
} from '@/packages/idp/utils/idp-analytics';
import { track } from '@/utils/analytics';

export interface DeleteActivityDialogProps {
  onClose: () => void;
  activity: Activity;
  planId: string;
}

export const DeleteActivityDialog = ({
  onClose,
  activity,
  planId,
}: DeleteActivityDialogProps) => {
  const { toast } = useNotification();
  const { mutate: deleteActivity, isPending } = useDeletePlanActivity(planId);
  const plan = useIdpPlan(planId);

  const handleDeleteActivity = (activity: Activity) => {
    deleteActivity(
      {
        activityId: activity.id,
      },
      {
        onSuccess: () => {
          track(
            IdpEvent.ActivityDeleted,
            buildIdpActivityProperties(plan, activity)
          );
          toast({ content: 'Atividade deletada com sucesso', type: 'success' });
          onClose();
        },
        onError: () => {
          toast({
            content:
              'Ocorreu um erro ao excluir a atividade. Tente novamente mais tarde',
            type: 'error',
          });
          onClose();
        },
      }
    );
  };

  return (
    <BaseDialog
      maxWidth="sm"
      fullWidth
      title="Tem certeza de que quer excluir esta atividade?"
      icon={<Icon name="siren-rounded" />}
      actionsComponent={
        <>
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => handleDeleteActivity(activity)}
            loading={isPending}
          >
            Excluir Atividade
          </Button>
        </>
      }
    >
      <Typography>
        A atividade será excluída do seu plano e essa ação não poderá ser
        desfeita.
      </Typography>
    </BaseDialog>
  );
};
